import React, { useState, useEffect, useMemo } from "react";
import Sidebar from "../Sidebar/Sidebar";
import "./AllFlights.css";
import { 
  fetchAllMissions,
  // fetchPilotTimeFilterStats
} from "../Apis/AdminApis";
import { useNavigate, useLocation } from "react-router-dom";
import pavamanLogo from "../images/drone.png"; 
import { FiPlayCircle,FiSearch, FiFilter,FiChevronUp, FiX, FiChevronLeft,FiChevronDown, FiChevronRight,FiBarChart2} from "react-icons/fi";

const AllFlights = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [allMissions, setAllMissions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isRestored, setIsRestored] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterStatus, setFilterStatus] = useState("all");
  const [sortConfig, setSortConfig] = useState({key: "start_time",direction: "desc"});
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedMinutes, setSelectedMinutes] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [paginationInfo, setPaginationInfo] = useState({
    current_page: 1,
    per_page: 10,
    total_records: 0,
    total_pages: 0
  });
  const [viewMode, setViewMode] = useState(null);
const [pilotTimeStats, setPilotTimeStats] = useState({
  total_missions: 0,
  total_sprayed_acres: 0,
  total_litres: 0,
  total_flight_hours: 0,
  vehicles: [],
});

const [isPilotStatsLoading, setIsPilotStatsLoading] = useState(false);
const [expandedMissionStats, setExpandedMissionStats] = useState(null);
const [timeFilterType, setTimeFilterType] = useState("");
const [appliedSearchTerm, setAppliedSearchTerm] = useState("");
const [appliedStartDate, setAppliedStartDate] = useState("");
const [appliedEndDate, setAppliedEndDate] = useState("");
const [appliedFilterStatus, setAppliedFilterStatus] = useState("all");
const [appliedMinutes, setAppliedMinutes] = useState("");
const [appliedTimeFilterType, setAppliedTimeFilterType] = useState("");
const [isPaginationLoading, setIsPaginationLoading] = useState(false);

useEffect(() => {
  if (!location.state?.filters) {
    setIsRestored(true);
    return;
  }

  const filters = location.state.filters;

  setCurrentPage(filters.currentPage || 1);
  setStartDate(filters.startDate || "");
  setEndDate(filters.endDate || "");
  setSearchTerm(filters.searchTerm || "");
  setFilterStatus(filters.filterStatus || "all");

  setSelectedMinutes(filters.selectedMinutes || "");
  setTimeFilterType(filters.timeFilterType || "");
setAppliedStartDate(filters.startDate || "");
setAppliedEndDate(filters.endDate || "");
setAppliedSearchTerm(filters.searchTerm || "");
setAppliedFilterStatus(filters.filterStatus || "all");
setAppliedMinutes(filters.selectedMinutes || "");
setAppliedTimeFilterType(filters.timeFilterType || "");
  setShowFilters(filters.showFilters || false);

  setIsRestored(true);

}, [location.state]);

// useEffect(() => {
//   if (!isRestored) return;

//   const debounce = setTimeout(() => {
//     loadAllMissions();
//   }, 500);

//   return () => clearTimeout(debounce);

// }, [
//   currentPage,
//   isRestored,
//   startDate,
//   endDate,
//   filterStatus,
//   searchTerm
// ]);

useEffect(() => {
  if (!isRestored) return;

  loadAllMissions();

}, [
  isRestored,
  currentPage,
  appliedStartDate,
  appliedEndDate,
  appliedSearchTerm,
  appliedFilterStatus,
  appliedMinutes,
  appliedTimeFilterType
]);

  useEffect(() => {
    const handleStorageChange = () => {
      setCurrentPage(1);
      setSearchTerm("");
      setFilterStatus("all");
      setStartDate("");
      setEndDate("");
      setSortConfig({ key: "start_time", direction: "desc" });
      loadAllMissions();
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

const loadAllMissions = async (filters = {}) => {
  const {
  startDate: sDate = startDate,
  endDate: eDate = endDate,
  searchTerm: sTerm = searchTerm,
  filterStatus: fStatus = filterStatus,
  selectedMinutes: sMinutes = selectedMinutes,
  timeFilterType: tType = timeFilterType,
  page = currentPage,
} = filters;
  try {
    setIsLoading(true);
    setError(null);

    const requestBody = {
  filter_type: "custom",

start_date:
  sDate || getDefaultStartDate(),

end_date:
  eDate || getDefaultEndDate(),

page,
  per_page: itemsPerPage,

status:
  fStatus !== "all"
    ? fStatus
    : undefined,

search: sTerm || undefined,

...(sMinutes && tType
  ? {
      time: `${sMinutes}min`,
      time_type: tType,
    }
  : {})
};

    const response = await fetchAllMissions(requestBody);
    if (response?.error) {
      if (response?.error?.includes("Unauthorized")) {
        setError("Session expired, redirecting to login page");
        setTimeout(() => {
          navigate("/login");
        }, 2000);
        return;
      }
      setError(response.error || "Failed to load all missions. Please try again.");
      return;
    }

    if (response) {
      let missionsData = [];
      let pagination = {};
      let currentViewMode = null;

      if (response.type === "single") {
        missionsData = response.missions || [];
        pagination = response.pagination || {};
        currentViewMode = response.view_mode || "admin";
        setViewMode(currentViewMode);
      } else if (response.type === "multi") {
        missionsData = response.superadmin?.missions || [];
        pagination = response.superadmin?.pagination || {};
        currentViewMode = "superadmin";
        setViewMode(currentViewMode);
      } else {
        missionsData = response.missions || [];
        pagination = response.pagination || {};
      }
      setAllMissions(missionsData);
      setPaginationInfo(pagination);
    } else {
      setAllMissions([]);
      setPaginationInfo({
        current_page: 1,
        per_page: 10,
        total_records: 0,
        total_pages: 0
      });
    }
  } catch (error) {
    console.error("Failed to load all missions:", error);
    if (error?.response?.status === 401 || error?.response?.data?.error?.includes("Unauthorized")) {
      setError("Session expired, redirecting to login page");
      setTimeout(() => {
        navigate("/login");
      }, 2000);
      return;
    }
    
    setError("Failed to load all missions. Please try again.");
  } finally {
    setIsLoading(false);
    setIsPaginationLoading(false);
  }
};

  const getDefaultStartDate = () => {
    const date = new Date();
    date.setMonth(date.getMonth() - 1);
    return date.toISOString().split('T')[0];
  };

  const getDefaultEndDate = () => {
    return new Date().toISOString().split('T')[0];
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };
const normalizeSearch = (text = "") =>
  text
    .toLowerCase()
    .replace(/\s+/g, "")
    .trim();
 
const calculatePilotStatsFromMissions = (missions = []) => {

  let totalMinutes = 0;
  let totalLitres = 0;
  let totalAcres = 0;

  const vehicleMap = {};

  missions.forEach((mission) => {
    totalMinutes += Number(
      mission.summary?.flying_time_minutes || 0
    );
    totalLitres += Number(
      mission.summary?.total_liters || 0
    );
   totalAcres += Number(
  mission.summary?.total_sprayed_acres || 0
);
    const vehicleId =
      mission.vehicle_id || "N/A";

    if (!vehicleMap[vehicleId]) {
      vehicleMap[vehicleId] = {
        vehicle_id: vehicleId,
        uin: mission.vehicle_uin || "N/A",
        mission_count: 0,
      };
    }

    vehicleMap[vehicleId].mission_count += 1;
  });

  return {
    total_missions: missions.length,
    total_sprayed_acres: totalAcres.toFixed(2),
    total_litres: totalLitres.toFixed(2),
    total_flight_minutes: totalMinutes.toFixed(2),
    vehicles: Object.values(vehicleMap),
  };
};
 
  const sortedMissions = [...allMissions].sort((a, b) => {
    if (sortConfig.key === "start_time") {
      const aTime = a.start_time ? new Date(a.start_time) : new Date(0);
      const bTime = b.start_time ? new Date(b.start_time) : new Date(0);
      return sortConfig.direction === "asc" ? aTime - bTime : bTime - aTime;
    }
    
    if (sortConfig.key === "duration") {
      const aStart = a.start_time ? new Date(a.start_time) : new Date(0);
      const aEnd = a.end_time ? new Date(a.end_time) : new Date(0);
      const bStart = b.start_time ? new Date(b.start_time) : new Date(0);
      const bEnd = b.end_time ? new Date(b.end_time) : new Date(0);
      const aDuration = aEnd - aStart;
      const bDuration = bEnd - bStart;
      return sortConfig.direction === "asc" ? aDuration - bDuration : bDuration - aDuration;
    }

    const aValue = String(a[sortConfig.key] || "");
    const bValue = String(b[sortConfig.key] || "");
    
    if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
    if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });

const filteredMissions = useMemo(() => {
  if (!appliedSearchTerm.trim()) return sortedMissions;

  const searchValue = appliedSearchTerm
    .toLowerCase()
    .replace(/\s+/g, "");
  return sortedMissions.filter((mission) => {
    const missionId = (mission.mission_id || "").toLowerCase().replace(/\s+/g, "");
    const pilotEmail = (mission.pilot_email || "").toLowerCase().replace(/\s+/g, "");
    const pilotName = (mission.pilot_name || "").toLowerCase().replace(/\s+/g, "");
    
    return (
      missionId.includes(searchValue) ||
      pilotEmail.includes(searchValue) ||
      pilotName.includes(searchValue)
    );
  });
}, [sortedMissions, appliedSearchTerm]);
  const handleSort = (key) => {
    setSortConfig(prevConfig => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === "desc" ? "asc" : "desc"
    }));
  };

  const getStatusColor = (status) => {
    const s = String(status || "").toLowerCase();

    switch (s) {
      case 'ended':
        return '#00B894';
      case 'started':
        return '#3498db';
      case 'paused':
        return '#FFA500';
      case 'failed':
        return '#e74c3c';
      default:
        return '#7f8c8d';
    }
  };

const handleReplay = (mission) => {
  navigate("/admin/mission-replay", {
    state: {
      missionData: mission,
      missionId: mission.mission_id,

      from: "all-flights",

     filters: {
    currentPage,
    startDate: appliedStartDate,
    endDate: appliedEndDate,
    searchTerm: appliedSearchTerm,
    filterStatus: appliedFilterStatus,
    selectedMinutes: appliedMinutes,
    timeFilterType: appliedTimeFilterType,
    showFilters
}
    }
  });
};

const handleApplyFilters = () => {

  setAppliedStartDate(startDate);
  setAppliedEndDate(endDate);
  setAppliedSearchTerm(searchTerm);
  setAppliedFilterStatus(filterStatus);
  setAppliedMinutes(selectedMinutes);
  setAppliedTimeFilterType(timeFilterType);

  setCurrentPage(1);
  setExpandedMissionStats(null);
};

  const handlePageChange = (newPage) => {
  if (newPage >= 1 && newPage <= totalPages) {
    setIsPaginationLoading(true);
    setCurrentPage(newPage);
  }
};
const handleClearFilters = () => {
  setCurrentPage(1);

  setStartDate("");
  setEndDate("");
  setSearchTerm("");
  setFilterStatus("all");

  setSelectedMinutes("");
  setTimeFilterType("");
setAppliedStartDate("");
setAppliedEndDate("");
setAppliedSearchTerm("");
setAppliedFilterStatus("all");
setAppliedMinutes("");
setAppliedTimeFilterType("");
  setExpandedMissionStats(null);
};

const toggleMissionStats = async (missionId, mission) => {
  if (expandedMissionStats === missionId) {
    setExpandedMissionStats(null);
  } else {
    setExpandedMissionStats(missionId);
    setIsPilotStatsLoading(true);
    
    try {
 const payload = {
  filter_type: "custom",

start_date: appliedStartDate || getDefaultStartDate(),
end_date: appliedEndDate || getDefaultEndDate(),

  drone_id: mission.vehicle_id,
  pilot_email: mission.pilot_email,

...(appliedMinutes && appliedTimeFilterType
  ? {
      time_type: appliedTimeFilterType,
      time: `${appliedMinutes}min`,
    }
  : {}),

  page: 1,
  per_page: 10
};
      
      const response = await fetchAllMissions(payload);
      
      let missionsList = [];
      if (response?.type === "single") {
        missionsList = response.missions || [];
      } else if (response?.type === "multi") {
        missionsList = response.superadmin?.missions || [];
      }
      const pilotMissions = missionsList.filter(
  (m) => m.mission_id === mission.mission_id
);
      const stats = calculatePilotStatsFromMissions(pilotMissions);
      
      setPilotTimeStats(prev => ({
        ...prev,
        [missionId]: stats
      }));
      
    } catch (err) {
      console.error("Error fetching stats:", err);
      setPilotTimeStats(prev => ({
        ...prev,
        [missionId]: {
          total_missions: 0,
          total_sprayed_acres: 0,
          total_litres: 0,
          total_flight_minutes: 0,
          vehicles: []
        }
      }));
    } finally {
      setIsPilotStatsLoading(false);
    }
  }
};
  const totalPages = paginationInfo.total_pages || 1;
  const totalRecords = paginationInfo.total_records || allMissions.length;
  const uniqueVehicles = [...new Set(allMissions.map(m => m.vehicle_id).filter(Boolean))];
  const uniquePilots = [...new Set(allMissions.map(m => m.pilot_email).filter(Boolean))];

  return (
    <div className="dashboard-wrapper">
      <Sidebar />
      
      <div className="dashboard-content">
        <div className="dashboard-header">
          <div className="header-left">
            <h1 className="dashboard-title">All Missions</h1>
            <p className="dashboard-subtitle">Complete mission history and details</p>
          </div>
          
          <div className="header-right">
            <button 
              className="filter-toggle-btn"
              onClick={() => setShowFilters(!showFilters)}
            >
              <FiFilter size={18} />
              {showFilters ? "Hide Filters" : "Show Filters"}
            </button>
            <button 
              className="af-back-btn"
              onClick={() => navigate("/admin/dashboard")}
            >
              ← Back to Dashboard
            </button>
          </div>
        </div>

        {showFilters && (
          <div className="filters-section-flights">
            <div className="filters-grid">
              <div className="filter-group">
                <label>Start Date</label>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  className="filter-input"
                />
              </div>
              <div className="filter-group">
                <label>End Date</label>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  className="filter-input"
                />
              </div>
            </div>
            <div className="filter-actions">
              <button className="apply-filters-btn" onClick={handleApplyFilters}>
                Apply Filters
              </button>
             <button
  className="reset-filters-btn"
  onClick={handleClearFilters}
>
  Clear Filters
</button>
            </div>
          </div>
        )}
<div className="table-controls" style={{ marginBottom: '20px', flexWrap: 'wrap' }}>
  <div className="pilot-search-wrapper">
    <input
      type="text"
      placeholder="Search by Mission ID, Pilot Name or Email..."
      className="pilot-search-input"
      value={searchTerm}
      onChange={(e) => {
        setCurrentPage(1);
        setSearchTerm(e.target.value);
      }}
    />
    {searchTerm && (
      <button className="clear-search-btn" onClick={() => setSearchTerm("")}>
        ✕
      </button>
    )}
  </div>

  <div className="pilot-time-filter">
    <div className="clock-icon">⏰</div>
    
    <select
      className="pilot-filter-select"
      value={timeFilterType}
      onChange={(e) => setTimeFilterType(e.target.value)}
    >
<option value="">Select Comparison</option>
                  <option value="lt">Shorter than (less than)</option>
                  <option value="gt">Longer than (greater than)</option>
                  <option value="eq">Approx Equal to</option>
    </select>
 <input
  type="number"
  min="0.5"
  max="120"
  step="0.5"
  value={selectedMinutes}
  onChange={(e) =>
    setSelectedMinutes(e.target.value)
  }
  className="minute-input"
  placeholder="Minutes"
/>
    
    <span className="minute-label">Minutes</span>
    
    <button className="apply-filter-btn" onClick={handleApplyFilters}>
      Apply Filters
    </button>
      <button
  className="reset-filters-btn"
  onClick={handleClearFilters}
>
  Clear Filters
</button>
  </div>
</div>

        {isLoading ? (
          <div className="custom-loading-container">
            <img
              src={pavamanLogo}
              alt="Loading"
              className="spinning-logo"
            />
            <p className="loading-text">
              Loading all missions data...
            </p>
          </div>
) : error ? (
  <div className="error-container">
    <div className="error-icon">⚠️</div>
    <h3>{error.includes("Session expired") ? "Session Expired" : "Error Loading Missions"}</h3>
    <p>{error}</p>
    {!error.includes("Session expired") && (
      <button 
        className="retry-btn"
        onClick={loadAllMissions}
      >
        Retry
      </button>
    )}
  </div>
) : (
          <>
            <div className="tr-table-container">
              <table className="tr-table">
                <thead className="tr-thead">
                  <tr>
                    <th>S.No</th>
                    <th className={sortConfig.key === "mission_id" ? "sorted" : ""}
                      onClick={() => handleSort("mission_id")}>
                      Mission ID
                      {sortConfig.key === "mission_id" && (
                        <span className="sort-arrow">{sortConfig.direction === "asc" ? "↑" : "↓"}</span>
                      )}
                    </th>
                    <th className={sortConfig.key === "vehicle_id" ? "sorted" : ""}
                      onClick={() => handleSort("vehicle_id")}>
                      Vehicle ID
                      {sortConfig.key === "vehicle_id" && (
                        <span className="sort-arrow">{sortConfig.direction === "asc" ? "↑" : "↓"}</span>
                      )}
                    </th>
                    <th>Pilot Email</th>
                    <th>Status</th>
                    <th>Flight Mode</th>
                    <th>Mission Type</th>
                    <th>Plot Name</th>
                    <th className={sortConfig.key === "start_time" ? "sorted" : ""}
                      onClick={() => handleSort("start_time")}>
                      Start Time
                      {sortConfig.key === "start_time" && (
                        <span className="sort-arrow">{sortConfig.direction === "asc" ? "↑" : "↓"}</span>
                      )}
                    </th>
                    <th>End Time</th>
                    <th>Replay</th>
                     <th>Action</th>
                  </tr>
                  
                </thead>
                <tbody>
  {filteredMissions.length > 0 ? (
    filteredMissions.map((mission, index) => (
      <React.Fragment key={mission.mission_id || index}>
        <tr>
          <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
          <td>
            <span className="mission-id">{mission.mission_id || "N/A"}</span>
          </td>
          <td>
            <span className="vehicle-tag">{mission.vehicle_id || "N/A"}</span>
          </td>
          <td>
            <div className="pilot-info">
              <span className="pilot-email">{mission.pilot_email || "N/A"}</span>
            </div>
          </td>
          <td>
            <span 
              className="status-badge"
              style={{ 
                background: `${getStatusColor(mission.status)}15`,
                color: getStatusColor(mission.status),
                borderColor: getStatusColor(mission.status)
              }}
            >
              {mission.status || "Unknown"}
            </span>
          </td>
          <td>{mission.flight_mode || "N/A"}</td>
          <td><span className="mission-type-badge">{mission.mission_type || "N/A"}</span></td>
          <td>{mission.plot_name || "N/A"}</td>
          <td>
            <div className="datetime-cell">
              {mission.start_time ? formatDateTime(mission.start_time) : "N/A"}
            </div>
          </td>
          <td>
            <div className="datetime-cell">
              {mission.end_time ? formatDateTime(mission.end_time) : "N/A"}
            </div>
          </td>
          <td>
            <button 
              className="replay-btn"
              onClick={() => handleReplay(mission)}
              title="Replay Mission"
            >
              <FiPlayCircle size={20} />
            </button>
          </td>
        <td>
  <button
    className="pv-expand-btn-modern"
    onClick={() => toggleMissionStats(mission.mission_id, mission)}
    title="View Statistics"
  >
    {expandedMissionStats === mission.mission_id ? (
      <FiChevronUp size={18} />
    ) : (
      <FiChevronDown size={18} />
    )}
  </button>
</td>
        </tr>
        {expandedMissionStats === mission.mission_id && (
          <tr className="mission-expanded-row">
            <td colSpan="12" className="mission-expanded-cell">
              {isPilotStatsLoading ? (
                <div className="expanded-loading">⏳ Loading stats...</div>
              ) : (
                <div className="mission-stats-container">
                  <div className="stats-cards-row">
                    <div className="stat-card-mini">
                      <div className="stat-icon-mini sprayed-icon">🌾</div>
                      <div className="stat-info">
                        <span className="stat-label-mini">Sprayed Acres</span>
                       <span className="stat-value-mini">
  {mission.summary?.total_sprayed_acres ?? 0}
</span>
                      </div>
                    </div>
                    
                    <div className="stat-card-mini">
                      <div className="stat-icon-mini litres-icon">💧</div>
                      <div className="stat-info">
                        <span className="stat-label-mini">Litres Consumed</span>
                       <span className="stat-value-mini">
  {mission.summary?.total_liters ?? 0}
</span>
                      </div>
                    </div>
                    
                    <div className="stat-card-mini">
                      <div className="stat-icon-mini time-icon">⏱️</div>
                      <div className="stat-info">
                        <span className="stat-label-mini">Flight Minutes</span>
                      <span className="stat-value-mini">
  {mission.summary?.flying_time_minutes ?? 0}
</span>
                      </div>
                    </div>
                  </div>
                  <div className="vehicle-details-section">
                    <div className="section-header">
                      <span className="section-title">🚁 Vehicle Details</span>
                    </div>
                    
                    {pilotTimeStats[mission.mission_id]?.vehicles?.length > 0 ? (
                      <div className="vehicle-cards-grid">
                        {pilotTimeStats[mission.mission_id]?.vehicles.map((v, idx) => (
                          <div key={idx} className="vehicle-card-mini">
                            <div className="vehicle-header-mini">
                              <span className="vehicle-id-mini">{v.vehicle_id}</span>
                            </div>
                            <div className="vehicle-details-mini">
                              <div className="detail-row">
                                <span className="detail-label">UIN:</span>
                                <span className="detail-value">{v.uin || "N/A"}</span>
                              </div>
                              <div className="detail-row">
                                <span className="detail-label">Missions:</span>
                                <span className="detail-value badge-missions">{v.mission_count}</span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="no-vehicle-data">No vehicle data available</div>
                    )}
                  </div>
                </div>
              )}
            </td>
          </tr>
        )}
      </React.Fragment>
    ))
  ) : (
    <tr>
      <td colSpan="12" className="no-data">
        <div className="no-data-content">
          <span className="no-data-icon">📭</span>
          <h4>No flights found</h4>
          <p>Try adjusting your search or filter criteria</p>
        </div>
      </td>
    </tr>
  )}
</tbody>
              </table>
            </div>

            {totalPages > 1 && (
  <div className="pv-pilot-pagination-wrapper">
    <div className="pv-pilot-pagination-controls">
      <button
        className="pv-pilot-pagination-btn"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1 || isPaginationLoading}
      >
        <FiChevronLeft size={16} />
        Previous
      </button>
      
      <div className="pv-pilot-page-numbers">
        {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
          let pageNumber;
          if (totalPages <= 5) {
            pageNumber = i + 1;
          } else if (currentPage <= 3) {
            pageNumber = i + 1;
          } else if (currentPage >= totalPages - 2) {
            pageNumber = totalPages - 4 + i;
          } else {
            pageNumber = currentPage - 2 + i;
          }
          
          return (
            <button
              key={pageNumber}
              className={`pv-pilot-page-btn ${currentPage === pageNumber ? 'pv-pilot-active' : ''}`}
              onClick={() => handlePageChange(pageNumber)}
              disabled={isPaginationLoading}
            >
              {pageNumber}
            </button>
          );
        })}
      </div>
      
      <button
        className="pv-pilot-pagination-btn"
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages || isPaginationLoading}
      >
        Next
        <FiChevronRight size={16} />
      </button>
    </div>
  </div>
)}
          </>
        )}
      </div>
    </div>
  );
};

export default AllFlights;